import { configureStore as configureStoreRTK } from "@reduxjs/toolkit";
import logger from "redux-logger";
import rootReducer from "../reducers";
import appLogger from "utils/logger";
import storage from "utils/storage";
import { AuthState } from "../reducers/auth";

const initialAuth: AuthState = {
  isSignedIn: false,
  isLoading: false,
  currentUser: null,
  currentAccount: null,
  accounts: [],
  adminView: false,
};

const loadState = () => {
  try {
    const access_token = storage.get("access-token");
    const currentAccount = storage.get("currentAccount");
    if (access_token) {
      return {
        auth: {
          ...initialAuth,
          isSignedIn: true,
          isLoading: true,
          currentAccount: currentAccount,
        },
      };
    } else {
      return { auth: initialAuth };
    }
  } catch (err) {
    appLogger.error(err);
    return { auth: initialAuth };
  }
};

export default function configureStore() {
  return configureStoreRTK({
    reducer: rootReducer,
    preloadedState: loadState(),
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware();
      if (import.meta.env.DEV) {
        return middleware.concat(logger);
      }
      return middleware;
    },
  });
}

export type AppStore = ReturnType<typeof configureStore>;
export type AppDispatch = AppStore["dispatch"];
